<template>
  <div>
    <MasterLayout>
      <div class="fuel_consumption_row">
        <div
          class="fuel_consumption_row_right_section_nw pump__bg py-5"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.92), rgb(12, 4, 31, 0.92)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              flex: '0 0 100%',
            },
          ]"
        >
          <div class="align-items-center" style="height: 100%">
            <div class="text-center">
              <div
                class="transaction_period_text text-center branch__sales__text"
                style="font-size: 22px"
              >
                {{ $route.query.region }}
              </div>
            </div>
            <!-- <div
							class="col-md-5 drop_down_input_group sales_transaction_dropdown"
						>
							<div class="drop_down_section mt-2 mr-2">
								<div class="drop_down_div align-items-center">
									<vue-ctk-date-time-picker
										v-model="dateRange"
										:max-date="maxDate"
										:range="true"
										:autoClose="true"
										:locale="this.$root.$i18n.locale"
										:custom-shortcuts="customShortcuts"
										:color="$store.getters.getDatePickerColor"
										format="DDMMYYYY"
										formatted="DD/MM/YYYY"
										:label="$t('text.calendar.dateRange')"
									/>
								</div>
							</div>
						</div> -->
          </div>
        </div>
      </div>

      <div class="mt-3">
        <section class="section__row">
          <div class="mt-3">
            <div class="branch__sales__text_header">
              <div class="row top_section_row" v-show="!showLoader">
                <div class="col-md-8 sec_text_color">
                  <span>
                    <img src="@/assets/img/hand (1).png" class="mr-3" />
                    {{ $route.query.region }} sales from
                    {{
                      $d(
                        new Date($route.query.startDate),
                        "short",
                        this.$root.$i18n.locale
                      )
                    }}
                    to
                    {{
                      $d(
                        new Date($route.query.endDate),
                        "short",
                        this.$root.$i18n.locale
                      )
                    }}
                  </span>
                  <span></span>
                </div>
                <div class="col-md-4 text-right"></div>
              </div>
              <ejs-grid
                v-show="!showLoader"
                ref="dataGrid"
                :dataBound="dataBound"
                :created="refreshGrid"
                :allowPaging="true"
                :allowSorting="true"
                :pageSettings="pageSettings"
                :toolbar="toolbar"
                :searchSettings="search"
                :allowExcelExport="true"
                :allowPdfExport="true"
                :toolbarClick="toolbarClick"
                :locale="usedLang"
              >
                <e-columns>
                  <e-column width="40" field="index" headerText="#"></e-column>

                  <e-column
                    field="branchName"
                    width="200"
                    :headerText="$t('text.cDashboard.station')"
                  ></e-column>

                  <e-column
                    field="state"
                    width="200"
                    :headerText="$t('text.cDashboard.state')"
                  ></e-column>

                  <e-column
                    field="region"
                    width="280"
                    :headerText="$t('text.cDashboard.region')"
                  ></e-column>
                  <e-column
                    field="pmsVolume"
                    width="200"
                    format="N2"
                    :headerText="`${countryProducts.products.product1} ${$t(
                      'text.cDashboard.productVolume'
                    )}`"
                  ></e-column>
                  <e-column
                    field="pmsAmount"
                    width="200"
                    format="N2"
                    :headerText="`${countryProducts.products.product1}  
					  ${$t('text.cDashboard.productAmount')}`"
                  ></e-column>
                  <e-column
                    field="agoVolume"
                    width="200"
                    format="N2"
                    :headerText="`${countryProducts.products.product2} ${$t(
                      'text.cDashboard.productVolume'
                    )}`"
                  ></e-column>
                  <e-column
                    field="agoAmount"
                    width="200"
                    format="N2"
                    :headerText="`${countryProducts.products.product2} Amount`"
                  ></e-column>
                  <e-column
                    field="dpkVolume"
                    width="200"
                    format="N2"
                    :headerText="`${countryProducts.products.product3} ${$t(
                      'text.cDashboard.productVolume'
                    )}`"
                  ></e-column>
                  <e-column
                    field="dpkAmount"
                    width="200"
                    format="N2"
                    :headerText="`${countryProducts.products.product3} Amount`"
                  ></e-column>
                  <e-column
                    field="lpgVolume"
                    width="200"
                    format="N2"
                    :headerText="`${countryProducts.products.product4} ${$t(
                      'text.cDashboard.productVolume'
                    )}`"
                  ></e-column>
                  <e-column
                    field="lpgAmount"
                    width="200"
                    format="N2"
                    :headerText="`${countryProducts.products.product4} Amount`"
                  ></e-column>

                  <e-column
                    field="totalAmount"
                    width="200"
                    format="N2"
                    :headerText="$t('text.cDashboard.total')"
                  ></e-column>
                </e-columns>
              </ejs-grid>
              <TableLoader :showLoader="showLoader" />
            </div>
          </div>
        </section>
        <div id="rentalListCan"></div>
        <!-- PDF DEISGN START -->

        <!-- PDF DESIGN ENDS -->
      </div>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Company/MasterLayout.vue";
import backgroundUrl from "@/assets/img/MobileWallet.png";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import countryProducts from "@/products";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Region Sales Report",
  name: "RegionSalesReport",
  components: {
    MasterLayout,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      // countryProducts: localStorage.getItem('countryProducts') ? JSON.parse(localStorage.countryProducts) : countryProducts,
      formatOptions: { type: "dateTime", format: "dd/MM/yyyy hh:mm a" },
      hasLpg: false,
      hasPms: false,
      hasAgo: false,
      hasDpk: false,
      productCount: "col-lg-3",
      cardCount: 0,
      transKeep: [],
      totalPmsVol: 0,
      totalManualPmsVol: 0,
      totalAgoVol: 0,
      totalManualAgoVol: 0,
      totalDpkVol: 0,
      totalManualDpkVol: 0,
      totalLpgVol: 0,
      totalManualLpgVol: 0,
      totalPmsVariance: 0,
      totalAgoVariance: 0,
      totalDpkVariance: 0,
      totalLpgVariance: 0,
      totalVol: 0,
      totalManualVol: 0,
      totalPmsVariance: 0,
      totalAgoVariance: 0,
      totalDpkVariance: 0,
      totalLpgVariance: 0,
      totalVariance: 0,
      branchIcon: "",
      company: "",
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      transFilter: this.$t("text.varianceReport.showAll"),
      startDate: this.$moment().subtract(1, "days").format("MMMM D, YYYY"),
      endDate: this.$moment().subtract(1, "days").format("MMMM D, YYYY"),
      pluginStartDate: this.$moment().subtract(1, "days").format("D-M-YYYY"),
      pluginEndDate: this.$moment().subtract(1, "days").format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      backgroundUrl,
      branch: {},
      branchId: null,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      branches: 0,
      dealers: 0,
      salesTransactions: [],
      showLoader: false,
      showAll: false,
      lowTanks: [],
      products: [],
      pmsCheck: 0,
      agoCheck: 0,
      dpkCheck: 0,
      lpgCheck: 0,
      totalCheck: 0,
      pmsRate: 0,
      agoRate: 0,
      dpkRate: 0,
      lpgRate: 0,
      todaysDate: new Date(),
      activeTab: "chart",
      productSummary: [],
      showTransactionOptions: false,
      salesTransationsCount: 0,
      company: null,
    };
  },
  created() {
    this.dateRange.start = this.pluginStartDate;
    this.dateRange.end = this.pluginEndDate;
    if (localStorage.getItem("userDetails") === "null") {
      this.$router.push({ path: "/" });
    } else if (configObject.authConfig() === null) {
      window.location.reload();
    }
    if (localStorage.getItem("userDetails") !== "null") {
      this.getCompanyBranchSales();
    }

    //this.showLoader = true;

    // let date = new Date();
    // let year = date.getFullYear();
    // let month = date.getMonth();
    // let day = date.getDay();
    // this.todaysDate = day + "-" + month + "-" + year;
    // this.todaysDate = this.$moment(date, "DD-MM-YYYY").format("MMMM D, YYYY");
  },
  computed: {
    countryProducts: function () {
      return this.$store.getters.getCountryProducts;
    },
  },
  watch: {
    company(company) {
      if (company !== null) {
        this.getCompanyBranchSales();
      }
    },
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );

        this.getCompanyBranchSales();
      }
    },
  },
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },

  methods: {
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    dataBound: function () {
      this.$refs.dataGrid.autoFitColumns();
    },
    // ?startDate=${this.startDate}&endDate=${this.endDate}`,
    getCompanyBranchSales() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Sale/CompanyRegionSales/CompanyRegionSales/${this.$route.query.regionId}?startDate=${this.$route.query.startDate}&endDate=${this.$route.query.endDate}`,

          configObject.authConfig()
        )
        .then((response) => {
          let groupArrays;

          response.data.sort((a, b) => {
            var x = a.branchName.toLowerCase();
            var y = b.branchName.toLowerCase();
            if (x < y) {
              return -1;
            }
            if (x > y) {
              return 1;
            }
            return 0;
          });
          let groups;

          groups = response.data.reduce((groups, sales) => {
            const branchName = sales.branchName;

            if (!groups[branchName]) {
              groups[branchName] = [];
            }
            groups[branchName].push(sales);
            return groups;
          }, {});

          let count = 0;
          groupArrays = Object.keys(groups).map((branchName) => {
            const pmsV = groups[branchName].filter(
              (sl) =>
                sl.productName.toLowerCase() ==
                this.countryProducts.productsLower.product1
            );
            const agoV = groups[branchName].filter(
              (sl) =>
                sl.productName.toLowerCase() ==
                this.countryProducts.productsLower.product2
            );
            const dpkV = groups[branchName].filter(
              (sl) =>
                sl.productName.toLowerCase() ==
                this.countryProducts.productsLower.product3
            );
            const lpgV = groups[branchName].filter(
              (sl) =>
                sl.productName.toLowerCase() ==
                this.countryProducts.productsLower.product4
            );

            return {
              index: ++count,
              branchName,
              region: groups[branchName][0].region,
              state: groups[branchName][0].state,
              regionId: groups[branchName][0].regionId,
              pmsVolume: pmsV.length
                ? this.convertThousand(pmsV[0].volumeSold)
                : "0.00",
              pmsAmount: pmsV.length
                ? this.convertThousand(pmsV[0].amountSold)
                : "0.00",
              agoVolume: agoV.length
                ? this.convertThousand(agoV[0].volumeSold)
                : "0.00",
              agoAmount: agoV.length
                ? this.convertThousand(agoV[0].amountSold)
                : "0.00",
              dpkVolume: dpkV.length
                ? this.convertThousand(dpkV[0].volumeSold)
                : "",
              dpkAmount: dpkV.length
                ? this.convertThousand(dpkV[0].amountSold)
                : "",
              lpgVolume: lpgV.length
                ? this.convertThousand(lpgV[0].volumeSold)
                : "0.00",
              lpgAmount: lpgV.length
                ? this.convertThousand(lpgV[0].amountSold)
                : "0.00",
              totalAmount: this.convertThousand(
                groups[branchName].reduce((acc, currValue) => {
                  return acc + currValue.amountSold;
                }, 0)
              ),
            };
          });

          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: groupArrays,
          });
          this.refreshGrid();
          this.showLoader = false;
        })
        .catch((error) => {});
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
<style>
@page {
  margin: 0;
}
@media screen and (max-width: 768px) {
  .card_container.ml-3 {
    margin-top: 15px;
  }

  .fuel_consumption_button.installed__tanks_dropdown__row {
    height: 113px !important;
    text-align: center;
  }

  .field-input[data-v-74507c40] {
    position: relative;
    width: 100%;
    height: 56px;
  }

  .fuel_consumption_row_right_section_nw {
    height: 214px;
  }

  .fuel_consumption_row .fuel_consumption_row_right_section_nw {
    margin-top: 16px;
  }

  .transaction_period_text.text-center.branch__sales__text {
    margin-top: -11px;
  }

  .drop_down_input_group.sales_transaction_dropdown {
    margin-top: -97px;
    margin-left: 26px;
  }
}
</style>
